import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { EquipmentService } from '../../../../services/equipment.service';
import { Equipment } from '../../../../models/equipment';
import { JobService } from '../../../../services/job.service';
import { Job } from '../../../../models/job';
import * as moment from 'moment';
import { Page } from '../../../../models/paging/page';

@Component({
  selector: 'app-job-manage',
  templateUrl: './job-manage.component.html',
  styleUrls: ['./job-manage.component.scss']
})
export class JobManageComponent implements OnInit {

  id: string = null;
  job: any;
  companyId: number = 0;
  editMode: boolean = false;

  page = new Page();
  rows = Array<Equipment>();
  loading: boolean = false;
  constructor(private router: Router, private route: ActivatedRoute, private snotifyService: SnotifyService, public jobService: JobService, public equipmentService: EquipmentService) { }

  ngOnInit(): void {
    this.job = new Job();

    this.page.pageNumber = 0;
    this.page.size = 9999999;

    var id = this.router.parseUrl(this.router.url).queryParams["id"];
    //console.log(id);
    if (id != null) {
      this.jobService.getById(id).then((e) => {
        this.job = e;
        //console.log(this.job);
        this.editMode = true;

        if (this.job.proposed_Date != null && this.job.proposed_Date != undefined)
          this.job.proposed_Date = moment(this.job.proposed_Date).toDate();
        if (this.job.week_Commencing != null && this.job.week_Commencing != undefined)
          this.job.week_Commencing = moment(this.job.week_Commencing).toDate();

        this.loadJobEquipment();
      });
    }
  }

  back() {
    this.router.navigate(['admin/jobs']);
  }

  validate() {
   
    if (this.job.location_Id == null || this.job.location_Id == "" || this.job.location_Id == 0) {
      this.snotifyService.error("Please enter a Location");
      return false;
    }   
    if (this.job.engineer_Id == null || this.job.engineer_Id == "" || this.job.engineer_Id == 0) {
      this.snotifyService.error("Please enter a Engineer");
      return false;
    }


    return true;
  }

  async save() {
    if (!this.validate()) {
      return;
    }
    //console.log(this.job);

    if (this.job.proposed_Date != null && this.job.proposed_Date != undefined)
      this.job.proposed_Date = moment(this.job.proposed_Date).format("YYYY-MM-DD");
    if (this.job.week_Commencing != null && this.job.week_Commencing != undefined)
      this.job.week_Commencing = moment(this.job.week_Commencing).format("YYYY-MM-DD");

    if (this.job.job_No == '')
      this.job.job_No = 0;

    this.job.contract_No = String(this.job.contract_No);
    this.job.selectedIds = [];

    for (var i = 0; i < this.rows.length; i++) {
      var e = this.rows[i];
      if (e.selected)
        this.job.selectedIds.push(e.core_Id);
    }


    if (!this.editMode)
      await this.jobService.add(this.job);
    else
      await this.jobService.update(this.job);

    if (this.job.job_No == 0)
      this.job.job_No = '';

    if (this.job.proposed_Date != null && this.job.proposed_Date != undefined)
      this.job.proposed_Date = moment(this.job.proposed_Date).toDate();
    if (this.job.week_Commencing != null && this.job.week_Commencing != undefined)
      this.job.week_Commencing = moment(this.job.week_Commencing).toDate();

    this.router.navigate(['admin/jobs']);
  }

  async delete() {
    await this.jobService.delete(this.id);
    this.router.navigate(['admin/jobs']);
  }

  onCompanyChange(value) {
    if (value == undefined)
      this.job.company_Id = undefined;
    else
      this.job.company_Id = value.id;

  }


  onLocationChange(value) {

    if (value == undefined) {
      this.job.location_Id = undefined;
      this.job.contract_No = undefined;
    }
    else {
      this.job.location_Id = value.id;
      this.job.contract_No = value.contract_No;
      this.loading = true;
      this.loadJobEquipment();

    }
  }
  loadJobEquipment() {
    this.equipmentService.getResults(this.page, 0, this.job.location_Id, 0, '', '', '').then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      //console.log(this.rows);
      this.loading = false;

      this.updateJobEquipment();
    });
  }

  updateJobEquipment() {

    if ((this.rows != null && this.rows.length > 0) && (this.job.selectedIds != null && this.job.selectedIds.length > 0)) {
      for (var i = 0; i < this.rows.length; i++) {
        var e = this.rows[i];

        for (var ii = 0; ii < this.job.selectedIds.length; ii++) {
          var ids = this.job.selectedIds[ii];

          if (e.core_Id == ids)
            e.selected = true;
        }

      }
    }
  }
  onTechnicanChange(value) {
    if (value == undefined)
      this.job.engineer_Id = undefined;
    else
      this.job.engineer_Id = value.id;

  }

  week_CommencingChanged() {

    var today = moment(this.job.week_Commencing);
    var start = today.startOf('week').add(1,'days');

    var formatted = start.format("DD/MM/YYYY");
    var commencing = moment(this.job.week_Commencing).format("DD/MM/YYYY");

    if (formatted != commencing) {
      this.snotifyService.error("The weekly commencing date is not the start of the week");
      this.snotifyService.error("This has been set to the start of the week now");

      this.job.week_Commencing = moment(this.job.week_Commencing).startOf('week').add(1, 'days').toDate();

    }

  }
  onReportTypeChange(value) {
    if (value == undefined)
      this.job.report_Type_Id = undefined;
    else
      this.job.report_Type_Id = value.id;
  }
  onDescriptionChange(value) {
    if (value == undefined) {
      this.job.item_Code = undefined;
      this.job.description = undefined;
    } else {
      this.job.item_Code = value.id;
      this.job.description = value.description;
    }
  }

  setCompanyId(company) {
    //console.log(company);
    if (company.id != null) {
      this.companyId = company.id;
    }
  }

  select(row) {
    row.selected = !row.selected;
  }
}
